import React from 'react'
import { BaseExample } from './BaseExample'

function App() {
  return (
    <div className="App">
      <BaseExample />
    </div>
  )
}

export default App
